export default __webpack_public_path__ + "static/media/respuestaproIconosbarra-01.bbe2d1fe.png";